import { Button } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import { memo } from "react";

interface ButtonAddQuestionProps {
	onClick: () => void;
}
const ButtonAddQuestion: React.FC<ButtonAddQuestionProps> = ({ onClick }) => {
	return (
		<Button
			variant="contained"
			size="large"
			className="bg-gray-950 !text-white"
			startIcon={<Iconify icon="ic:round-plus" />}
			onClick={onClick}
		>
			Thêm câu hỏi
		</Button>
	);
};
export default memo(ButtonAddQuestion);
